module.exports = __webpack_public_path__ + "img/814-f635e7.png";